import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import { Group, Line } from 'react-konva';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { selectDsmEdits } from 'store/slices/RoofDataSlice/roofSelector';
import { POLYGON_FILL } from './FlattenAreaPolygon';

// View-mode fill only; kept as main-layer's first child so everything else renders above it.
export default function FlattenAreaFillLayer() {
	const baseImageScale = useKonvaImageScale();
	const { treeEditingMode } = useSelector((state: RootState) => state.treeSlice.data);
	const { flattenArea: savedFlattenArea } = useSelector(selectDsmEdits);

	if (treeEditingMode) return null;

	return (
		<Group name="flatten-area-fill" scale={baseImageScale} listening={false}>
			{savedFlattenArea.map((polygon) => {
				const points = polygon.coords?.flat() ?? [];
				if (points.length < 6) return null;
				return (
					<Line
						key={polygon.id}
						id={`FLATTEN_AREA_FILL-${polygon.id}`}
						points={points}
						closed
						fill={POLYGON_FILL}
					/>
				);
			})}
		</Group>
	);
}
